import { DateOnly } from '@if/core/date'
import { EPaymentFrequency, EPaymentPlan } from '@if/core/types'
import * as yup from '@if/core/yup'
import { EProtectionPlanCoverage } from '@src/data/api/calculator/calculator-api'
import { DEFAULT_ERS_SCORE } from './hooks/creditRatingBands'

// Nothing is `required()`: the form runs in `filters` mode, which validates on every change,
// so a required rule would flag fields the agent has not reached yet. `compute` decides when
// the form is complete enough to quote.
export const standaloneCalculatorSchema = yup.object({
  financingProgramId: yup.string().nullable().defined(),
  provinceIso: yup.string().nullable().defined(),
  merchantId: yup.string().nullable().defined(),
  amountRequested: yup.number().nullable().defined().positive(),
  paymentPlanId: yup.string().nullable().defined(),
  paymentFrequency: yup.mixed<EPaymentFrequency>().required(),
  activationDate: yup.dateOnly().nullable().defined(),
  firstPaymentDate: yup.dateOnly().nullable().defined(),
  protectionPlan: yup.mixed<EProtectionPlanCoverage>().required(),
  // The backend falls back to the prequalified maximum term, and programs that do not price
  // on ERS ignore the score entirely.
  ersScore: yup.number().nullable().defined().positive(),
  term: yup.number().nullable().defined().positive(),
})

export type StandaloneCalculatorValues = yup.InferDraft<typeof standaloneCalculatorSchema>

export const STANDALONE_CALCULATOR_DEFAULTS: StandaloneCalculatorValues = {
  financingProgramId: '',
  provinceIso: '',
  ersScore: DEFAULT_ERS_SCORE,
  merchantId: null,
  amountRequested: null,
  term: null,
  paymentPlanId: EPaymentPlan.RegularDailyInterests,
  paymentFrequency: EPaymentFrequency.Monthly,
  activationDate: DateOnly.today(),
  firstPaymentDate: null,
  protectionPlan: EProtectionPlanCoverage.None,
}
